<!-- =========================================================================================
    File Name: Email.vue
    Description: Email Application (Inbox)
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div id="email-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden">

        <vs-sidebar class="items-no-padding" parent="#email-app" :click-not-close="clickNotClose" :hidden-background="clickNotClose" v-model="isEmailSidebarActive">
            <email-sidebar :emailTags="emailTags" @closeSidebar="toggleEmailSidebar" :mailFilter="mailFilter" />
        </vs-sidebar>

        <div :class="{'sidebar-spacer': clickNotClose}" class="border border-solid d-theme-border-grey-light border-r-0 border-t-0 border-b-0" style="min-height: 80vh">

            <!-- SEARCH BAR -->
            <div class="flex border d-theme-dark-bg items-center">
                <feather-icon class="md:inline-flex lg:hidden ml-4 mr-4 cursor-pointer" icon="MenuIcon" @click.stop="toggleEmailSidebar(true)"/>
                <vs-input icon-no-border icon="icon-search" size="large" icon-pack="feather" placeholder="Search Mail" v-model="searchQuery" class="vs-input-no-border vs-input-no-shdow-focus w-full" />
            </div>

            <!-- EMAIL ACTION BAR -->
            <div class="email__actions flex items-center flex-wrap justify-between p-4 border border-r-0 border-l-0 border-solid d-theme-border-grey-light">

                <div class="flex">

                    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer" v-if="mailFilter != 'sent'">

                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="moveTo('NEW')" v-if="mailFilter != 'NEW'">
                              <span class="flex items-center">
                                <feather-icon icon="MailIcon" svgClasses="h-4 w-4" class="mr-2" />
                                <span>Входящие</span>
                              </span>
                            </vs-dropdown-item>

                            <vs-dropdown-item @click="moveTo('ACCEPTED')" v-if="mailFilter != 'ACCEPTED'">
                              <span class="flex items-center">
                                <feather-icon icon="Edit2Icon" svgClasses="h-4 w-4" class="mr-2" />
                                <span>Принятый</span>
                              </span>
                            </vs-dropdown-item>

                            <vs-dropdown-item @click="moveTo('COMPLETED')" v-if="mailFilter != 'COMPLETED'">
                              <span class="flex items-center">
                                <feather-icon icon="CheckIcon" svgClasses="h-4 w-4" class="mr-2" />
                                <span>Завершенный</span>
                              </span>
                            </vs-dropdown-item>

                            <vs-dropdown-item @click="moveTo('NOT_ACCEPTED')" v-if="mailFilter != 'NOT_ACCEPTED'">
                              <span class="flex items-center">
                                <feather-icon icon="InfoIcon" svgClasses="h-4 w-4" class="mr-2" />
                                <span>Отмененный</span>
                              </span>
                            </vs-dropdown-item>

                            <vs-dropdown-item @click="moveTo('RE_UPLOAD')" v-if="mailFilter != 'RE_UPLOAD'">
                              <span class="flex items-center">
                                <feather-icon icon="InfoIcon" svgClasses="h-4 w-4" class="mr-2" />
                                <span>Повторные расмотрение</span>
                              </span>
                            </vs-dropdown-item>

                            <vs-dropdown-item @click="moveTo('FAIL')" v-if="mailFilter != 'FAIL'">
                              <span class="flex items-center">
                                <feather-icon icon="InfoIcon" svgClasses="h-4 w-4" class="mr-2" />
                                <span>Тех. ошибки</span>
                              </span>
                            </vs-dropdown-item>

                        </vs-dropdown-menu>
                    </vs-dropdown>

                </div>
            </div>

            <!-- EMAILS LIST -->
            <component :is="scrollbarTag" class="email-content-scroll-area" :settings="settings" ref="mailListPS" :key="$vs.rtl">
                <transition-group name="list-enter-up" class="email__mails" tag="ul" appear>
                    <li class="cursor-pointer email__mail-item" v-for="(mail, index) in mails" :key="index" @click="updateOpenMail(mail.id)" :style="{transitionDelay: (index * 0.1) + 's'}">
                        <mail-item :mail="mail" :isSelected="isMailSelected(mail.id)" @addToSelected="addToSelectedMails" @removeSelected="removeSelectedMail" />
                    </li>

                </transition-group>

              <div class="my-5" style="justify-content: flex-start; margin: 20%">
                <vs-pagination style="justify-content: flex-start;" :total="countPagination" v-model="currentPage"></vs-pagination>
              </div>
            </component>
        </div>

        <!-- EMAIL VIEW SIDEBAR -->
        <email-view
            :emailTags       = "emailTags"
            :openMailId      = "openMailId"
            :isSidebarActive = "isSidebarActive"
            :mailFilter      = "mailFilter"
            @markUnread      = "updateSingleMarkUnread"
            @removeMail      = "removeOpenMail"
            @previousMail    = "previousMail"
            @nextMail        = "nextMail"
            @moveTo          = "moveCurrentTo"
            @closeSidebar    = "closeMailViewSidebar">
        </email-view>

    </div>
</template>

<script>
import EmailSidebar        from './EmailSidebar.vue'
import MailItem            from './MailItem.vue'
import EmailView           from './EmailView.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moduleEmail         from '@/store/email/moduleEmail.js'

export default {
  data () {
    return {
      openMailId           : null,
      currentPage           : 1,
      selectedMails        : [],
      isSidebarActive      : false,
      showThread           : false,
      clickNotClose        : true,
      isEmailSidebarActive : true,
      settings             : {
        maxScrollbarLength : 60,
        wheelSpeed         : 0.30
      }
    }
  },
  watch: {
    async currentPage (value) {
      this.currentPage = parseInt(value)
      await this.$router.push({ query: { page: value }})
      await this.$store.dispatch('email/fetchEmails', { filter: this.$route.params.filter, page: value })
      if (value === this.countPagination) {
        location.reload()
      }
    },
    isSidebarActive (value) {
      if (!value) this.showThread = false
    },
    mailFilter () {
      this.selectedMails = []

      const scroll_el = this.$refs.mailListPS.$el || this.$refs.mailListPS
      scroll_el.scrollTop = 0

      this.$store.commit('email/UPDATE_MAIL_FILTER', this.$route.params.filter)
      this.$store.dispatch('email/fetchEmails', { filter: this.$route.params.filter })
      this.toggleEmailSidebar()
    },
    windowWidth () {
      this.setSidebarWidth()
    }
  },
  computed: {
    countPagination () {
      return Number(Math.ceil(this.paginationMeta.total / this.paginationMeta.per_page))
    },
    mailFilter () {
      return this.$route.params.filter
    },
    emailTags () {
      return ['Thesis']
    },
    paginationMeta () {
      return this.$store.state.email.meta
    },
    searchQuery: {
      get () {
        return this.$store.state.email.mailSearchQuery
      },
      set (val) {
        this.$store.dispatch('email/setEmailSearchQuery', val)
      }
    },
    selectAllCheckBox: {
      get () {
        return this.selectedMails.length
      },
      set (value) {
        value ? this.selectedMails = this.mails.map(mail => mail.id) : this.selectedMails = []
      }
    },
    mails () {
      return this.$store.getters['email/filteredMails']
    },
    selectAllIcon () {
      return this.selectedMails.length === this.mails.length ? 'icon-check' : 'icon-minus'
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    isMailSelected () {
      return (mailId) => this.selectedMails.indexOf(mailId) !== -1
    },
    windowWidth () {
      return this.$store.state.windowWidth
    }
  },
  methods: {
    updateOpenMail (mailId) {
      this.openMailId = mailId
      this.isSidebarActive = true
    },
    addToSelectedMails (mailId) {
      if (this.selectedMails.indexOf(mailId) === -1) this.selectedMails.push(mailId)
    },
    removeSelectedMail (mailId) {
      const mailIndex = this.selectedMails.indexOf(mailId)
      if (mailIndex !== -1) this.selectedMails.splice(mailIndex, 1)
    },
    moveTo (to) {
      const payload = { emailIds: this.selectedMails, to }
      this.$store.dispatch('email/moveMailsTo', payload)
        .catch((error) => { console.error(error) })
      this.selectedMails = []
    },
    moveCurrentTo (to) {
      this.selectedMails = [this.openMailId]
      this.moveTo(to)
    },
    updateMarkUnread () {
      const payload = { emailIds: this.selectedMails, unreadFlag: true }
      this.$store.dispatch('email/setUnread', payload)
      this.selectedMails = []
    },
    removeOpenMail () {
      this.selectedMails = [this.openMailId]
      this.moveTo('trashed')
      this.isSidebarActive = false
    },
    toggleIsStarred () {
      const payload = { mailId: this.currentMail.id, value: !this.currentMail.isStarred }
      this.$store.dispatch('email/toggleIsMailStarred', payload)
    },
    nextMail () {
      const currentMailIndex = this.mails.findIndex((mail) => mail.id === this.openMailId)
      if (this.mails[currentMailIndex + 1]) this.openMailId = this.mails[currentMailIndex + 1].id
    },
    previousMail () {
      const currentMailIndex = this.mails.findIndex((mail) => mail.id === this.openMailId)
      if (this.mails[currentMailIndex - 1]) this.openMailId = this.mails[currentMailIndex - 1].id
    },
    updateSingleMarkUnread () {
      this.selectedMails = [this.openMailId]
      this.updateMarkUnread()
      this.isSidebarActive = false
    },
    updateLabels (label) {
      this.$store.dispatch('email/updateLabels', { mails: this.selectedMails, label })
      this.selectedMails = []
    },
    closeMailViewSidebar () {
      this.isSidebarActive = false
    },
    setSidebarWidth () {
      if (this.windowWidth < 992) {
        this.isEmailSidebarActive = this.clickNotClose = false
      } else {
        this.isEmailSidebarActive = this.clickNotClose = true
      }
    },
    toggleEmailSidebar (value = false) {
      if (!value) {
        this.closeMailViewSidebar()
        if (this.clickNotClose) {
          return
        }
      }
      this.isEmailSidebarActive = value
    }
  },
  components: {
    MailItem,
    EmailSidebar,
    EmailView,
    VuePerfectScrollbar
  },
  async created () {
    this.currentPage = this.$route.query.page ? parseInt(this.$route.query.page) : 1

    this.$store.registerModule('email', moduleEmail)
    this.setSidebarWidth()

    await this.$store.commit('email/UPDATE_MAIL_FILTER', this.$route.params.filter)        // Update Mail Filter
    await this.$store.dispatch('email/fetchEmails', { filter: this.$route.params.filter, page: this.currentPage }) // Fetch Emails From API
    /*await this.$store.dispatch('email/fetchMeta') */ // Fetch Unread Mails
    await this.$store.dispatch('email/fetchTags')  // Fetch Mail Tags
  },
  beforeDestroy () {
    this.$store.unregisterModule('email')
  },
  mounted () {
    this.$store.dispatch('email/setEmailSearchQuery', '')
  }
}

</script>

<style>
.pagination {
  display: inline-block;
}

.pagination a {
  color: black;
  float: left;
  padding: 8px 16px;
  text-decoration: none;
}

.pagination a.active {
  background-color: #4CAF50;
  color: white;
}

.pagination a:hover:not(.active) {background-color: #ddd;}
</style>
<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
</style>
